<template>
  <component :is="component"
             v-bind="cData"
             v-on="$listeners"
  />
</template>


<script>
  export default {
    props: {
      path: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        component: null,
      };
    },
    async created() {
      this.component = await this.loadComponent();
    },
    methods: {
      async loadComponent() {
        try {
          const domain = String(this.$domain.current().slug).toUpperCase();
          return (await import(`../content/${domain}/${this.path}.vue`)).default;
        } catch (e) {
          try {
            return (await import(`../content/${this.path}.vue`)).default;
          } catch {
            console.error('UNKNOWN COPY COMPONENT PATH!');
            return null;
          }
        }
      }
    }
  }
</script>
